export default __webpack_public_path__ + "static/media/1797.97199630.png";